import React, { Suspense, lazy } from 'react';

const PMDashboard = lazy(() => import('../components/ProjectManagement/PMDashboard'));

const ProjectManagement: React.FC = () => {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Loading Project Management...</p>
        </div>
      </div>
    }>
      <PMDashboard />
    </Suspense>
  );
};

export default ProjectManagement;
